import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import LinkWrapper from 'pricing-pages-ui-components/components/LinkWrapper';
import { useHistory } from 'react-router-dom';
import { NavItemEnum } from '../../../../constants/routing/NavItems';
import { useCurrentNavItem } from '../../../../hooks/useCurrentNavItem';
import { trackClickedLink, trackTooltipInteraction } from '../../../../v2/utils/tracking/trackingEventUtils';
import { useHighestProductLevelFromInventory } from '../../../hooks/inventory/useHighestProductLevel';
import { jsx as _jsx } from "react/jsx-runtime";
export const IncludedHubSpotCredits = ({
  includedProductLevelHubspotCredits,
  trackingSource
}) => {
  const history = useHistory();
  const currentNavItem = useCurrentNavItem();
  const {
    highestProductLevel: highestProductLevelOwned
  } = useHighestProductLevelFromInventory();
  const isFreeOrProspect = highestProductLevelOwned === 'FREE';
  const getTabForProduct = () => {
    if (currentNavItem === NavItemEnum.MARKETING_PLUS) {
      return NavItemEnum.MARKETING;
    }
    if (currentNavItem === NavItemEnum.FREE) {
      return NavItemEnum.SUITE;
    }
    // Handle null case
    return currentNavItem || NavItemEnum.SUITE;
  };
  const handleClick = () => {
    const url = isFreeOrProspect ? `/hubspot-credits?tab=${getTabForProduct()}` : '/hubspot-credits';
    trackClickedLink({
      name: 'learn-more-hubspot-credits-link',
      type: 'internal',
      url,
      trackingSource
    });
    history.push(url);
  };
  const learnMoreLink = /*#__PURE__*/_jsx(LinkWrapper, {
    onClick: handleClick,
    external: false,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedHubSpotCredits.cta"
    })
  });
  if (includedProductLevelHubspotCredits) {
    return /*#__PURE__*/_jsx(Tooltip, {
      placement: "bottom",
      maxInlineSize: "315px",
      onOpenChange: e => {
        if (e.currentTarget.value) {
          trackTooltipInteraction({
            action: 'hovered',
            name: 'included-hubspot-credits-tooltip',
            value: `${includedProductLevelHubspotCredits} HubSpot Credits`,
            trackingSource
          });
        }
      },
      headingText: /*#__PURE__*/_jsx(Text, {
        typography: "heading-300",
        color: "text-core-on-fill-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedHubSpotCredits.heading"
        })
      }),
      title: /*#__PURE__*/_jsx(View, {
        children: /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          color: "text-core-on-fill-default",
          children: /*#__PURE__*/_jsx(FormattedReactMessage, {
            message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedHubSpotCredits.tooltip",
            options: {
              learnMoreLink
            }
          })
        })
      }),
      children: /*#__PURE__*/_jsx(View, {
        cursor: "help",
        children: /*#__PURE__*/_jsx(Text, {
          typography: "body-100",
          color: "text-core-default",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricing-pages-ui.merchCardsV2.subtextDisplay.includedHubSpotCredits.credits",
            options: {
              numberOfCredits: includedProductLevelHubspotCredits
            }
          })
        })
      })
    });
  }
  return null;
};